
export type QuickFilterMode = "All" | "Unread" | "Flagged";

export const QuickFilterModes: QuickFilterMode[] = ["All", "Unread", "Flagged"];
